import React from 'react';

import { IconButton, Stack, useTheme } from '@mui/material';
import { Trash } from 'iconsax-reactjs';
import prettyBytes from 'pretty-bytes';
import { FileIcon } from 'react-file-icon';

import { DocumentStyled, SizeStyled, TitleStyled } from './styles';

interface IProps {
  file: File;
  onRemove: () => void;
}

const FormDocumentUploaded = React.memo(({ file, onRemove }: IProps) => {
  const theme = useTheme();

  return (
    <DocumentStyled>
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Stack direction="row">
          <Stack sx={{ marginRight: theme.spacing(1), width: '25px' }}>
            <FileIcon
              extension={file.name.split('.').pop() ?? 'pdf'}
              labelColor="#D14423"
              labelUppercase
              glyphColor="rgba(255,255,255,0.4)"
            />
          </Stack>

          <Stack spacing={0.5} overflow="hidden">
            <TitleStyled variant="sm">{file.name}</TitleStyled>

            <SizeStyled>{prettyBytes(file.size)}</SizeStyled>
          </Stack>
        </Stack>

        <IconButton onClick={onRemove} sx={{ padding: 0, height: '18px' }}>
          <Trash size={18} color={theme.palette.primary.main} />
        </IconButton>
      </Stack>
    </DocumentStyled>
  );
});

export default FormDocumentUploaded;
